/* unplugin-vue-components disabled */import script from "./DetailTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./DetailTable.vue?vue&type=script&lang=ts&setup=true"

import "./DetailTable.vue?vue&type=style&index=0&id=f623f96e&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f623f96e"]])

export default __exports__